import { QueryCache, QueryClient } from '@tanstack/react-query';
import { useCurrentUser } from '../state/use-current-user';
import { ApiError } from './api-client';

export const createQueryClient = (): QueryClient => {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error) => {
        // Any query that throws 401 means the session is gone or the user was deactivated.
        // useAuthMe/loadMe catch 401 internally (return null), so this only fires
        // for other queries — giving a clean redirect without double-handling.
        if (error instanceof ApiError && error.status === 401) {
          useCurrentUser.getState().clearUser();
          if (window.location.pathname !== '/login') {
            window.location.href = '/login';
          }
        }
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        gcTime: 5 * 60_000,
        // Never retry 401 — it means the session is gone and retrying only delays the redirect.
        retry: (failureCount, error) => !(error instanceof ApiError && error.status === 401) && failureCount < 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
};

export const queryClient = createQueryClient();
